import React, {Component} from "react";
import {connect} from "react-redux";
import Button from "../../components/Button";
import Loading from "../../components/Loading";
import TaskIcon from "./TaskIcon";
import AddressInline from "../../components/AddressInline";
import {
  requestAddShippingAddress, 
  requestChangeShippingAddress,
  requestEditShippingAddress,
} from "../../actions/CheckoutApiActions";
import AddressList from "./AddressList";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";

class SelectShippingAddress extends Component {

  constructor(props) {
    super(props);
    this.handleAddShippingAddress = this.handleAddShippingAddress.bind(this);
    this.handleChangeShippingAddress = this.handleChangeShippingAddress.bind(this);
    this.handleEditShippingAddress = this.handleEditShippingAddress.bind(this);
    this.handleUseSelectedAddress = this.handleUseSelectedAddress.bind(this);
    this.handleAddressListChange = this.handleAddressListChange.bind(this);
    this.state = {
      selectedAddressId: "",
      hasSelection: false,
      submittingAddress: false,
      error: false // not used at the moment.
    }
  }

  render() {
    return (
      <div className="SelectShippingAddress section">
        <TaskIcon nr="1" completed={this.props.status === "provided"} />
        <div className="title">Select Shipping Address</div>
        <div className="content">          
          {this.renderView(this.props.status)}          
        </div>
      </div>
    )
  }

  renderAddressProvided() {
    return (
      <React.Fragment>
        <AddressInline address={this.props.shippingAddress} inline={false} />
        <div className="buttons">
          <Button label="Edit address" primary={false} onClick={this.handleEditShippingAddress} active={this.props.canChangeAddress} />
          <Button label="Change address" primary={false} onClick={this.handleChangeShippingAddress} active={this.props.canChangeAddress} />
        </div>
      </React.Fragment>
    )
  }

  renderAddressRequest() {
    return (
      <React.Fragment>
        <p className="helptext">Add a shipping address by clicking on the button below. After you have provided an address and billing details, the order total will be calculated.</p>
        <Button label="Add shipping address" primary={true} onClick={this.handleAddShippingAddress} active={this.props.canChangeAddress} />
      </React.Fragment>
    )
  }

  renderSelectUsedAddress() {
    let selectLabel = this.state.submittingAddress ? "Standby..." : "Use selected address";
    return (
      <React.Fragment>
        <p className="helptext">Select one of your previously used addresses or add a new one using the buttons below.</p>
        <AddressList
          addresses={this.props.usedShippingAddresses}
          selectedId={this.state.selectedAddressId}
          onChange={this.handleAddressListChange}
          />
        <Button label={selectLabel} primary={true} onClick={this.handleUseSelectedAddress} active={this.state.hasSelection && !this.state.submittingAddress} />
        <Button label="Add other address" primary={false} onClick={this.handleAddShippingAddress} active={this.props.canChangeAddress} visible={!this.state.submittingAddress} />   
        <Loading show={this.state.submittingAddress} />
      </React.Fragment>
    )
  }

  renderView(shippingAddressStatus) {
    switch(shippingAddressStatus) {
      case "provided":
        return this.renderAddressProvided();
      default:
        if (this.props.usedShippingAddresses.size > 0) {
          return this.renderSelectUsedAddress();
        }
        return this.renderAddressRequest();
    }
  }

  handleAddShippingAddress() {
    this.props.requestAddShippingAddress(this.props.accountId, this.props.orderId);
  }

  handleChangeShippingAddress() {
    this.props.requestChangeShippingAddress(this.props.accountId, this.props.orderId);
  }

  handleEditShippingAddress() {
    this.props.requestEditShippingAddress(this.props.accountId, this.props.orderId);
  }

  handleUseSelectedAddress() {
    this.setState({submittingAddress: true, error: false});
    this.props.assignExistingShippingAddress({orderId: this.props.orderId, accountId: this.props.accountId, addressId: this.state.selectedAddressId})
      .then((response) => {
        this.setState({submittingAddress: false});
      })
      .catch((err) => {
        this.setState({submittingAddress: false, error: true});
      })
  }

  handleAddressListChange(id) {
    this.setState({
      selectedAddressId: id,
      hasSelection: true
    })
  }

}

SelectShippingAddress.defaultProps = {
  canChangeAddress: true,
  canSetDeliveryInstructions: false
}

const ASSIGN_EXISTING_ADDRESS = gql`
  mutation assignExistingShippingAddress($data: OrderExistingShippingAddressInput!) {
    assignExistingShippingAddress(input: $data) {
      errors { key message }
    }
  }
`

const withQueries = compose(
  graphql(ASSIGN_EXISTING_ADDRESS, {
    props: ({ mutate }) => ({
      assignExistingShippingAddress: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {
  requestAddShippingAddress, 
  requestChangeShippingAddress,
  requestEditShippingAddress,
})(withQueries(SelectShippingAddress));